export default [
  {
    path: '/activity-20260724-main',
    component: () => import('./Page.vue'),
    meta: { title: '超级夏日活动', id: 38 },
  },
  {
    path: '/activity-20260724-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '超级夏日活动-规则', id: 38 },
  },
]
